module.exports = __webpack_public_path__ + "img/ZAR10034.82c92ea2.png";